import React from 'react';
import { Navbar } from '../Navbar';
import { Footer } from '../Footer';
import { useTheme } from '../providers/ThemeProvider';
export const TermsOfServicePage = () => {
  const {
    theme
  } = useTheme();
  const isDark = theme === 'dark';
  return <div className={`min-h-screen ${isDark ? 'bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50]' : 'bg-gradient-to-r from-gray-50 to-gray-100'}`} data-id="element-10376">
      <Navbar data-id="element-10377" />

      {/* Main Content */}
      <div className="pt-20 pb-16" data-id="element-10378">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-10379">
          <div className={`${isDark ? 'bg-navy-800' : 'bg-white'} rounded-xl shadow-lg p-8 md:p-12`} data-id="element-10380">
            <h1 className={`text-4xl font-bold mb-8 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-10381">
              Terms of Service
            </h1>

            <div className={`prose prose-lg max-w-none ${isDark ? 'prose-invert' : ''}`} data-id="element-10382">
              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-10383">
                <strong data-id="element-10384">Last Updated:</strong> January 15, 2025
              </p>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-10385">
                Welcome to Maestro Connect ("Maestro Connect," "we," "us," or
                "our"), operated by Maestro Connect, Inc. These Terms of Service
                ("Terms") govern your access to and use of the Maestro Connect
                platform, including our website, applications, dashboards, and
                related services (collectively, the "Platform").
              </p>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-10386">
                By accessing or using Maestro Connect, you agree to be bound by
                these Terms. If you do not agree, you may not use the Platform.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-10387">
                1. Eligibility & Accounts
              </h2>

              <h3 className={`text-xl font-semibold mt-6 mb-3 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-10388">
                1.1 Age Requirements
              </h3>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-10389">
                <li data-id="element-10390">
                  Maestro Connect is intended for users 18 years of age or
                  older.
                </li>
                <li data-id="element-10391">
                  Parents or legal guardians may create and manage accounts on
                  behalf of minors.
                </li>
                <li data-id="element-10392">
                  By creating an account for a minor, the parent or guardian
                  represents that they have full legal authority to do so and
                  accepts responsibility for the minor's use of the Platform.
                </li>
              </ul>

              <h3 className={`text-xl font-semibold mt-6 mb-3 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-10393">
                1.2 Account Responsibility
              </h3>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-10394">
                <li data-id="element-10395">
                  You agree to provide accurate, complete, and current
                  information.
                </li>
                <li data-id="element-10396">
                  You are responsible for maintaining the confidentiality of
                  your login credentials.
                </li>
                <li data-id="element-10397">
                  You are fully responsible for all activity that occurs under
                  your account.
                </li>
              </ul>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-10398">
                We reserve the right to suspend or terminate accounts that
                violate these Terms.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-10399">
                2. Nature of the Platform
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-10400">
                Maestro Connect is a lesson organization, scheduling, and
                management platform designed to help teachers and students
                coordinate educational activities.
              </p>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-10401">
                Maestro Connect does NOT:
              </p>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-10402">
                <li data-id="element-10403">Guarantee lesson outcomes or educational results</li>
                <li data-id="element-10404">Provide instruction or teaching services</li>
                <li data-id="element-10405">Verify teacher qualifications</li>
                <li data-id="element-10406">Supervise or monitor live lessons</li>
              </ul>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-10407">
                Live instruction and communication may occur via third-party
                services (such as Zoom, Google Meet, or similar tools). Maestro
                Connect is not responsible for those services.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-10408">
                3. Teachers & Students
              </h2>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-10409">
                <li data-id="element-10410">
                  Teachers are solely responsible for their lesson content,
                  conduct, scheduling, and interactions with students.
                </li>
                <li data-id="element-10411">
                  Students and parents are responsible for selecting teachers
                  and determining suitability.
                </li>
                <li data-id="element-10412">
                  Maestro Connect is not a party to any agreement between
                  teachers and students.
                </li>
              </ul>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-10413">
                Any disputes between users must be resolved directly between
                those users.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-10414">
                4. Payments & Subscriptions
              </h2>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-10415">
                <li data-id="element-10416">
                  Payments are processed by third-party payment providers,
                  including Paddle.
                </li>
                <li data-id="element-10417">
                  Maestro Connect does not store credit card or banking
                  information.
                </li>
                <li data-id="element-10418">
                  Pricing, subscriptions, and features may change at any time.
                </li>
                <li data-id="element-10419">
                  All subscription payments are final unless otherwise stated.
                </li>
                <li data-id="element-10420">
                  Refunds may be issued at the sole discretion of Maestro
                  Connect in exceptional cases.
                </li>
              </ul>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-10421">
                We are not responsible for payment processor errors, delays, or
                outages.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-10422">
                5. Acceptable Use
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-10423">
                You agree not to:
              </p>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-10424">
                <li data-id="element-10425">Harass, abuse, threaten, or exploit others</li>
                <li data-id="element-10426">Upload unlawful, harmful, or inappropriate content</li>
                <li data-id="element-10427">Use the Platform for illegal or unauthorized purposes</li>
                <li data-id="element-10428">
                  Attempt to access systems, data, or accounts without
                  authorization
                </li>
                <li data-id="element-10429">Reverse engineer, scrape, or disrupt the Platform</li>
              </ul>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-10430">
                Violation of these rules may result in suspension or permanent
                termination.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-10431">
                6. User Content & Ownership
              </h2>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-10432">
                <li data-id="element-10433">You retain ownership of content you create or upload.</li>
                <li data-id="element-10434">
                  By using the Platform, you grant Maestro Connect a limited,
                  non-exclusive, royalty-free license to host, store, display,
                  and process content solely to operate the Platform.
                </li>
                <li data-id="element-10435">
                  Maestro Connect is not responsible for user-generated content
                  and does not endorse any user content.
                </li>
              </ul>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-10436">
                7. Platform Availability & Changes
              </h2>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-10437">
                <li data-id="element-10438">The Platform is provided "as is" and "as available."</li>
                <li data-id="element-10439">
                  We do not guarantee uninterrupted service or error-free
                  operation.
                </li>
                <li data-id="element-10440">
                  Features may be added, modified, or removed at any time
                  without notice.
                </li>
              </ul>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-10441">
                8. Limitation of Liability
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-10442">
                To the maximum extent permitted by law:
              </p>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-10443">
                <li data-id="element-10444">
                  Maestro Connect shall not be liable for indirect, incidental,
                  consequential, or special damages.
                </li>
                <li data-id="element-10445">
                  We are not liable for educational outcomes, personal disputes,
                  financial losses, or data loss.
                </li>
                <li data-id="element-10446">
                  Our total liability shall not exceed the amount paid by you to
                  Maestro Connect in the preceding 12 months.
                </li>
              </ul>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-10447">
                9. Indemnification
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-10448">
                You agree to indemnify and hold harmless Maestro Connect, its
                officers, directors, employees, and affiliates from any claims,
                damages, losses, or expenses arising from:
              </p>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-10449">
                <li data-id="element-10450">Your use of the Platform</li>
                <li data-id="element-10451">Your violation of these Terms</li>
                <li data-id="element-10452">Your interactions with other users</li>
              </ul>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-10453">
                10. Termination
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-10454">
                We may suspend or terminate your access:
              </p>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-10455">
                <li data-id="element-10456">For violation of these Terms</li>
                <li data-id="element-10457">For misuse of the Platform</li>
                <li data-id="element-10458">At our discretion, with or without notice</li>
              </ul>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-10459">
                Upon termination, your right to use the Platform ends
                immediately.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-10460">
                11. Governing Law
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-10461">
                These Terms are governed by the laws of the State of Delaware,
                without regard to conflict-of-law principles.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-10462">
                12. Changes to These Terms
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-10463">
                We may update these Terms from time to time. Continued use of
                the Platform after changes constitutes acceptance of the updated
                Terms.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-10464">
                13. Contact Us
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-10465">
                If you have questions about these Terms, contact us at:
              </p>

              <div className={`${isDark ? 'bg-navy-700' : 'bg-gray-50'} p-6 rounded-lg mb-6`} data-id="element-10466">
                <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-10467">
                  <strong data-id="element-10468">Email:</strong>{' '}
                  <a href="mailto:support@maestroconnect.com" className="text-deep-pink hover:underline" data-id="element-10469">
                    support@maestroconnect.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer data-id="element-10470" />
    </div>;
};